<template>
  <div>
    <el-date-picker
      class="!w-full"
      v-model="billDate"
      type="month"
      :clearable="false"
      placeholder="选择月"
      value-format="yyyy-MM"
      v-show="dateType === 'month'"
    >
    </el-date-picker>

    <el-date-picker
      class="!w-full"
      v-show="dateType === 'day'"
      v-model="billDate"
      :editable="false"
      type="datetimerange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
    >
    </el-date-picker>
  </div>
</template>

<script>
import { reactive, watch, toRefs } from '@vue/composition-api'
import { DateTime } from 'luxon'
export default {
  // 组件名称
  name: 'DateSelect',
  props: {
    dateType: {
      type: String,
      default: 'month',
    },
    defaultData: {
      request: false,
    },
  },
  components: {},
  setup(_, { emit }) {
    const state = reactive({
      billDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM'),
    })
    watch(
      () => state.billDate,
      (val) => {
        if (val) {
          emit('input', val)
        }
      },
      {
        immediate: true,
      },
    )
    watch(
      () => _.defaultData,
      (val) => {
        if (val) {
          state.billDate = val
        }
      },
      {
        immediate: true,
      },
    )
    watch(
      () => _.dateType,
      (val) => {
        if (val === 'month') {
          state.billDate = _.defaultData
        }
      },
    )

    const reset = (val) => {
      state.billDate = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM')
    }

    return {
      ...toRefs(state),
      reset,
    }
  },
}
</script>
